import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import "./NavBar.scss";

const NavBar = React.memo((props) => {
  const dispatch = useDispatch();
  const t = useSelector(selectText);
  return (
    <div className="NavBar">
      <div
        className={`left${!props.leftAction ? " disabled" : ""}`}
        onClick={(e) => props.leftAction && dispatch(props.leftAction)}
      >
        {props.leftAction && <i className="icon-back" />}
      </div>
      <div className="title">{t(props.label)}</div>
      <div
        className="right"
        onClick={(e) => props.rightAction && dispatch(props.rightAction)}
      >
        <i className="icon-close" />
      </div>
    </div>
  );
});

export default NavBar;
